import { DataFieldConfig } from './data-builder';
import { NestedHome } from '@habity/types';
import { filterProviderData } from './utils';
import {
  isHouse,
  isCottage,
  isHousingCooperative,
  isFarm,
} from '@habity/types/vitec';

// Create dynamic fields based on renovations data
export const createRenovationsFields = (context: {
  home: NestedHome;
}): DataFieldConfig[] => {
  const { home } = context;
  const { provider_data, provider_type } = home || {};
  if (!provider_data || !provider_type) return [];

  const filteredProviderData = filterProviderData(provider_data);
  let renovations: string | undefined;

  // Get renovations from different sources based on estate type
  if (
    isHouse(filteredProviderData, provider_type) ||
    isCottage(filteredProviderData, provider_type)
  ) {
    // @ts-ignore
    const { building } = filteredProviderData || {};
    renovations = building?.renovations;
  } else if (isHousingCooperative(filteredProviderData, provider_type)) {
    const { association } = filteredProviderData || {};
    // @ts-ignore
    renovations = association?.renovations;
  } else if (isFarm(filteredProviderData, provider_type)) {
    const { mainResidentialBuilding } = filteredProviderData || {};
    // @ts-ignore
    renovations = mainResidentialBuilding?.renovations;
  }

  if (!renovations) return [];

  // Split renovations by line breaks and create a field for each
  const renovationLines = renovations
    .split('\r\n')
    .filter((line) => line.trim());

  return renovationLines.map((renovation, index) => ({
    key: `renovation_${index}`,
    label: '', // No label for renovation items
    getValue: () => renovation,
    condition: () => true,
  }));
};
